import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useLocation } from "wouter";
import { useLanguage } from "@/contexts/LanguageContext";
import robinPhoto from "@assets/1678270794100_1771852265016.jpeg";

export default function ExpertContact() {
  const [, setLocation] = useLocation();
  const { language, localePath } = useLanguage();
  const nl = language === 'nl';

  return (
    <section className="py-24 relative bg-grad-ink border-t border-white/5 breathing overflow-hidden">
      <div className="container mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mx-auto flex max-w-4xl flex-col items-center gap-10 md:flex-row md:gap-14"
        >
          <img src={robinPhoto} alt="Robin de Wildt, digital marketeer Wrkt Digital" loading="lazy" className="h-44 w-44 shrink-0 rounded-full border-2 border-[#4CEAAC]/40 object-cover object-top shadow-[0_0_40px_rgba(76,234,172,0.15)] md:h-52 md:w-52" />
          <div className="text-center md:text-left">
            <h3 className="text-[#4CEAAC] text-xs font-semibold tracking-[0.18em] uppercase mb-4">Contact</h3>
            <h2 className="text-4xl md:text-[56px] font-display font-bold leading-[1.04] tracking-[-0.03em] mb-5">
              {nl ? <>Praat met een <span className="text-[#4CEAAC]">expert</span>.</> : <>Talk to an <span className="text-[#4CEAAC]">expert</span>.</>}
            </h2>
            <p className="text-white/60 leading-relaxed mb-7 max-w-xl">
              {nl
                ? 'Voor de kennismaking duiken we alvast in je merk en kanalen, zodat het gesprek meteen over jou gaat. We werken bewust met een klein aantal merken tegelijk.'
                : 'Before the intro call we already dive into your brand and channels, so the conversation is about you from minute one. We deliberately work with a small number of brands at a time.'}
            </p>
            <div className="flex flex-col items-center gap-4 sm:flex-row md:items-start">
              <button
                onClick={() => setLocation(localePath("/contact"))}
                className="btn btn--gradient btn--lg"
                data-testid="button-contact-robin"
              >
                {nl ? 'Plan een kennismaking' : 'Book an intro call'} <ArrowRight className="w-5 h-5" />
              </button>
            </div>
            <p className="mt-5 text-sm text-white/40">Robin de Wildt · {nl ? 'Digital marketeer D2C brands' : 'Digital marketer D2C brands'}</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
